/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employee_selfservice_TimeCorrectionSpanResponse } from './employee_selfservice_TimeCorrectionSpanResponse';
export type employee_selfservice_TimeCorrectionRequestResponse = {
    /**
     * Date is the corrected day.
     */
    date: string;
    /**
     * DecisionReason is the office's reason, set only for a rejected request.
     */
    decision_reason?: string;
    /**
     * DeltaMinutes is new minus old net minutes.
     */
    delta_minutes: number;
    /**
     * ID is the change request id.
     */
    id: string;
    /**
     * Mode is the rule at submit: shift (time tracking off) or tracking.
     */
    mode: employee_selfservice_TimeCorrectionRequestResponse.mode;
    /**
     * New is the requested span.
     */
    new: employee_selfservice_TimeCorrectionSpanResponse;
    /**
     * Old is what the day counted at submit.
     */
    old: employee_selfservice_TimeCorrectionSpanResponse;
    /**
     * Reason is the employee's reason.
     */
    reason: string;
    /**
     * ShiftID is the corrected shift; absent on a day without one.
     */
    shift_id?: string;
    /**
     * Status is the request's workflow state.
     */
    status: employee_selfservice_TimeCorrectionRequestResponse.status;
    /**
     * SubmittedAt is when the employee filed the request.
     */
    submitted_at: string;
};
export namespace employee_selfservice_TimeCorrectionRequestResponse {
    /**
     * Mode is the rule at submit: shift (time tracking off) or tracking.
     */
    export enum mode {
        SHIFT = 'shift',
        TRACKING = 'tracking',
    }
    /**
     * Status is the request's workflow state.
     */
    export enum status {
        PENDING = 'pending',
        APPROVED = 'approved',
        EXECUTED = 'executed',
        FAILED = 'failed',
        MANUAL = 'manual',
        REJECTED = 'rejected',
        RESOLVED = 'resolved',
        CANCELLED = 'cancelled',
    }
}

